import { render, staticRenderFns } from "./CustomerPurchaseOrderDashboard.vue?vue&type=template&id=bee2e1be&lang=pug&"
import script from "./CustomerPurchaseOrderDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerPurchaseOrderDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports